import React, { useState } from 'react';
import ConfirmModal from './ConfirmModal';
import { usePozadi, useEsc } from './modalHooks';

// Společný modální dialog. Zavření pozadím nebo Esc se u dialogu, v němž uživatel něco změnil
// (změna v libovolném poli), zeptá „Zahodit změny?“. Tlačítka v dialogu volají onZavrit přímo.
export default function Modal({ nadpis, children, onZavrit }) {
  const [zmeneno, setZmeneno] = useState(false);
  const [dotaz, setDotaz] = useState(false);
  const chtitZavrit = () => { if (zmeneno) setDotaz(true); else onZavrit(); };
  const pozadi = usePozadi(chtitZavrit);
  useEsc(() => { if (!dotaz) chtitZavrit(); });
  const zmena = () => setZmeneno(true);
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, overflowY: 'auto' }} {...pozadi}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '20px', maxWidth: '520px', width: 'calc(100% - 24px)', margin: '16px auto' }}
        onChange={zmena} onInput={zmena}>
        <h3 style={{ marginTop: 0 }}>{nadpis}</h3>
        {children}
      </div>
      {dotaz && (
        <ConfirmModal message="Zahodit změny?" confirmLabel="Zahodit" danger zIndex={1100}
          onConfirm={onZavrit} onCancel={() => setDotaz(false)} />
      )}
    </div>
  );
}
